// Détecte la source d'une URL vidéo et produit l'URL d'intégration.
// Supporte : YouTube (Shorts, watch, youtu.be), TikTok, Instagram (Reel/Post), MP4/WebM direct.
export function getVideoEmbed(url = "") {
    const yt = url.match(/(?:youtube\.com\/(?:shorts\/|watch\?v=)|youtu\.be\/)([\w-]{6,})/);
    if (yt) {
        return { provider: "youtube", kind: "iframe", embedUrl: `https://www.youtube-nocookie.com/embed/${yt[1]}` };
    }
    const tt = url.match(/tiktok\.com\/@[\w.-]+\/video\/(\d+)/);
    if (tt) {
        return { provider: "tiktok", kind: "iframe", embedUrl: `https://www.tiktok.com/embed/v2/${tt[1]}` };
    }
    const ig = url.match(/instagram\.com\/(reel|reels|p)\/([\w-]+)/);
    if (ig) {
        const type = ig[1] === "p" ? "p" : "reel";
        return { provider: "instagram", kind: "iframe", embedUrl: `https://www.instagram.com/${type}/${ig[2]}/embed` };
    }
    if (/\.(mp4|webm|mov)(\?.*)?$/i.test(url)) {
        return { provider: "file", kind: "video", embedUrl: url };
    }
    return { provider: "other", kind: "iframe", embedUrl: url };
}
